import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { mapSharedPropertiesToFields, SitecoreFieldTypes } from '@gn-audio/jss-components';

import { ComponentProps } from 'lib/component-props';

import { Slider, SliderProps } from './Slider';

export type SliderSpotProps = {
  fields: SliderProps;
} & ComponentProps;

const SliderSpot = ({ fields }: SliderSpotProps): React.ReactElement => {
  const { header, cards } = mapSharedPropertiesToFields<SliderProps>(fields as SitecoreFieldTypes);

  return (
    <div className="container-fluid overflow-hidden">
      <div className="container !py-0">
        <Slider header={header} cards={cards} />
      </div>
    </div>
  );
};

export default withDatasourceCheck()<SliderSpotProps>(SliderSpot);
